var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17.3333,
    r: 12,
    fill: "#F5DADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4798 8.85286C26.1577 10.5312 27.3002 12.6694 27.7629 14.9971C28.2256 17.3248 27.9877 19.7374 27.0793 21.9299C26.171 24.1223 24.6329 25.9963 22.6596 27.3147C20.6863 28.6331 18.3664 29.3368 15.9932 29.3368C13.62 29.3368 11.3 28.6331 9.32673 27.3147C7.35343 25.9963 5.81536 24.1223 4.90699 21.9299C3.99862 19.7374 3.76075 17.3248 4.22346 14.9971C4.68616 12.6694 5.82866 10.5312 7.5065 8.85286",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66667V16",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7ba68a9a44d6cc2c9059fd7fc615bb93.svg";
export { ForwardRef as ReactComponent };